module.exports = "\r\n<div> \r\n\r\n  <iframe src=\"http://deva.aac.es/seguimientotitulos/common/historialPublico.asp?idtitulo=780&v=y72Vqy52xgqo4aBJUZXKpqbsEpkiUvnCxtr'\"></iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/modules/general/historial/historial.component.html
// module id = ../../../../../src/app/modules/general/historial/historial.component.html
// module chunks = main